import { useLocation } from "react-router-dom";
import { Maximize2, X, Sparkles, RotateCcw } from "lucide-react";
import { useAssistant } from "./AssistantProvider";
import ConversationView from "./ConversationView";
import useKeyboardOpen from "../../lib/useKeyboardOpen";

const LABELS = {
  trip: "This trip",
  live: "Live trip",
  budget: "Budget",
  presence_act60: "Act 60 presence",
  scenarios: "Scenarios",
  wishlist: "Wishlist",
  search: "Search",
  you_settings: "You",
  trips: "Trips",
  home: "Home",
  paste_email: "Paste email",
};

export default function AssistantPanel() {
  const { open, openAssistant, closeAssistant, expand, screenContext, panelSessionId, setPanelSessionId, getScreenContext, prefill } = useAssistant();
  const loc = useLocation();
  const kbOpen = useKeyboardOpen();

  const fabHidden = loc.pathname.startsWith("/plan/ai") || (kbOpen && !open);
  const fabBottom = loc.pathname.includes("/live") ? "bottom-40" : "bottom-24";
  const label = LABELS[screenContext?.screen] || null;

  return (
    <>
      {!open && !fabHidden && (
        <button
          onClick={() => openAssistant()}
          className={`md:hidden fixed ${fabBottom} right-4 z-50 w-12 h-12 rounded-full bg-ember text-cream shadow-float flex items-center justify-center active:scale-95 transition-transform`}
          data-testid="assistant-fab"
          aria-label="Ask Wandr"
        >
          <Sparkles size={20} />
        </button>
      )}

      {open && (
        <>
          <div className="fixed inset-0 z-[60] bg-ink/30 md:hidden" onClick={closeAssistant} data-testid="assistant-overlay" />
          <div
            className="fixed z-[70] flex flex-col bg-paper border-hairline inset-x-0 bottom-0 h-[85dvh] rounded-t-hero border-t shadow-float pb-[env(safe-area-inset-bottom)] md:inset-y-0 md:right-0 md:left-auto md:inset-x-auto md:h-auto md:w-[440px] md:rounded-none md:border-l md:pb-0"
            data-testid="assistant-panel"
          >
            <header className="flex items-center gap-2 px-4 py-3 border-b border-hairline shrink-0">
              <Sparkles size={15} className="text-ember shrink-0" />
              <span className="font-display font-medium text-base">Ask Wandr</span>
              {label && (
                <span className="ml-1 font-mono text-[10px] uppercase tracking-wide text-dusk bg-dusk/10 rounded-full px-2 py-0.5 truncate" data-testid="assistant-context-chip">
                  {label}
                </span>
              )}
              <div className="ml-auto flex items-center gap-0.5">
                <button onClick={() => setPanelSessionId(null)} title="New thread"
                  className="btn-swiss btn-ghost text-xs px-2 py-1.5" data-testid="assistant-new-thread">
                  <RotateCcw size={13} />
                </button>
                <button onClick={expand} title="Expand to full workspace"
                  className="btn-swiss btn-ghost text-xs px-2 py-1.5" data-testid="assistant-expand-btn">
                  <Maximize2 size={13} />
                </button>
                <button onClick={closeAssistant} title="Close"
                  className="btn-swiss btn-ghost text-xs px-2 py-1.5" data-testid="assistant-close-btn">
                  <X size={14} />
                </button>
              </div>
            </header>
            <ConversationView
              variant="panel"
              sessionId={panelSessionId}
              onSessionCreated={(s) => setPanelSessionId(s.id)}
              getContext={getScreenContext}
              prefill={prefill}
            />
          </div>
        </>
      )}
    </>
  );
}
